import React from "react";

const Boolean_Data_Types = () => {
  return (
    <div>
      <h1>Boolean_Data_Types Component</h1>
      <p>Content for Boolean_Data_Types goes here...</p>
    </div>
  );
};

export default Boolean_Data_Types;
